import React, { PropTypes } from 'react';
import Form, { FormActions, FormBody, DateInput, TextInput, SelectInput } from "../../Form";
import FormMultiSelectInput from "../../FormMultiSelectInput";
import { inject, observer } from 'mobx-react';
import { observable, action } from "mobx";
import moment from "moment/moment";
import { tools as api, observation } from '../../../actions/api';
import Spinner from "../../Spinner";
import { getDisplayDate } from "../../../libs/date";
import _ from 'lodash';
import Modal from '../../Modal';
import DataTable from '../../DataTable';

@inject('stationStore', 'parameterStore', 'qcFlagStore')
@observer
class DeleteObservation extends React.Component {

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  @observable loading = false;
  @observable deleting = false;
  @observable openDeleteDialog = false;
  @observable allSelected = false;
  @observable multiStationOptions = [];
  @observable multiParameterOptions = [];
  @observable filterByTimestamp = false;
  @observable filters = {
    date_from: moment().subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss'),
    date_to: moment().format('YYYY-MM-DDTHH:mm:ss'),
    timestamp_from: moment().subtract(1, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
    timestamp_to: moment().format('YYYY-MM-DDTHH:mm:ss'),
    time: '',
    qc_flag: '',
  };
  @observable observations = [];
  @observable login = {
    username: '',
    password: ''
  };

  @observable allChecked = false;

  @action onStationOptionClicked = item => item.value = !item.value;
  @action onParameterOptionClicked = item => item.value = !item.value;
  @action onChangeFilters = (field, value) => this.filters[field] = value;
  @action onChangeLogin = (field, value) => this.login[field] = value;
  @action onChangeFilterByTimestamp = e => this.filterByTimestamp = e.target.checked;

  componentWillMount() {
    const { stationStore, parameterStore } = this.props;

    if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
    if (!parameterStore.isLoading && parameterStore.items.length === 0) parameterStore.fetchItems();

    this.populateOptions();
  }

  populateOptions = () => {
    const { stationStore, parameterStore } = this.props;
    if (stationStore.items.length === 0 || parameterStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      if (process.env.NODE_ENV !== 'production') {
        // // view hydrology
        // // this.multiStationOptions = stationStore.items.map(item => ({id: item.id, label: item.name, tags: item.tags, value: [77,78,28,41,107].indexOf(item.id) > -1}));
        // this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, tags: item.tags, value: [28, 78, 238].indexOf(item.id) > -1 }));
        // this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, code: item.code, value: [2, 97].indexOf(item.id) > -1 }));
        // this.onView()

        // // view pollution
        // this.multiStationOptions = stationStore.items.map(item => ({id: item.id, label: item.name, tags: item.tags, value: [11, 107].indexOf(item.id) > -1}));
        // this.multiParameterOptions = parameterStore.items.map(item => ({id: item.id, label: item.name, value: [20, 34, 15, 12,3,274,23,24,8,6,31,30,54,105,106].indexOf(item.id) > -1}));
        // this.onView()

        // view imza
        this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, label: item.name, name: item.name, tags: item.tags, value: item.name.toLowerCase().indexOf('imza') > -1 }));
        this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, label: item.name, name: item.name, code: item.code, value: [109, 179].indexOf(item.id) > -1 }));
        // this.onView()
      } else {
        this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false, tags: item.tags }));
        this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false, code: item.code }));
      }
    }
  };

  optionsReducer = options => options.reduce((acc, item) => {
    if (item.value === true) acc.push(item.id);
    return acc;
  }, []);

  @action onView = e => {
    !!e && e.preventDefault();

    const { notify } = this.context;
    const { qcFlagStore } = this.props;
    let stations = this.optionsReducer(this.multiStationOptions).join(',');
    let parameters = this.optionsReducer(this.multiParameterOptions).join(',');

    if (stations === '' || parameters === '') {
      notify.error({ message: 'Missing fields' });
      return null;
    }

    let filters = Object.assign({}, { stations, parameters, ...this.filters });
    if (!this.filterByTimestamp) filters = Object.assign(filters, { timestamp_from: '', timestamp_to: '' });
    this.observations = [];
    this.loading = true;
    this.allSelected = false;

    api.deleteObservation.fetchObservation(filters).then(res => {
      this.loading = false;
      this.observations = res.map((item, index) => {
        let flags = qcFlagStore.getProperFlag(item.qc_flag);
        return Object.assign(item, {
          index: index,
          display_time: getDisplayDate(item.time),
          display_timestamp: getDisplayDate(item.timestamp),
          selected: false,
          hqc: flags[0], qc2: flags[1], qc1: flags[2], qc0: flags[3]
        })
      });
    }).catch(err => {
      console.log(err);
      notify.error({ message: err.toString() });
      this.loading = false;
    })
  };

  onChangeOpenDeleteDialog = e => {
    e && e.preventDefault();

    const { notify } = this.context;
    let selectedObservations = this.observations.filter(item => item.selected);
    if (selectedObservations.length === 0) {
      notify.error({ message: 'No observations selected.' });
      return null;
    }

    this.openDeleteDialog = !this.openDeleteDialog;
  };

  @action handleSelectAllChange = () => {
    this.allChecked = !this.allChecked;
    this.observations = this.observations.map(item => {
      item.selected = this.allChecked;
      return item;
    })
  }

  @action handleRowSelectChange = (item) => {
    this.observations = this.observations.map(i => {
      if (i.index === item.index) i.selected = !i.selected;
      return i;
    })
    item.checked = !item.checked;
    this.allChecked = false
  }

  onDelete = e => {
    e.preventDefault();

    const { notify } = this.context;

    let selectedObservations = this.observations.filter(item => item.selected);
    api.deleteObservation.verifyLogin(this.login).then(() => {
      /*global event, fdescribe*/
      /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
      if (confirm('Credentials verified. Delete Observation?')) {
        this.deleting = true;
        api.deleteObservation.deleteObservation(selectedObservations.map(item => _.omit(item, ['station_name', 'parameter_code', 'selected', 'display_time', 'display_timestamp', 'hqc', 'qc2', 'qc1', 'qc0', 'checked']))).then(() => {
          this.observations = this.observations.filter(item => selectedObservations.map(item => item.id).indexOf(item.id) === -1);
          this.deleting = false;
          this.openDeleteDialog = false;
          notify.success({ message: 'Observation deleted.' });
        }).catch(err => {
          console.log(err);
          notify.error({ message: err.toString() });
          this.deleting = false;
        })
      }
    }).catch(() => {
      notify.error({ message: 'Invalid login.' })
    })

  };

  render() {
    const { stationStore, parameterStore } = this.props;
    const columns = [
      { key: "checkbox", label: <input type="checkbox" name="" value="" checked={this.allChecked} onChange={this.handleSelectAllChange} /> },
      { key: 'id', label: 'ID' },
      { key: 'station_name', label: 'Station Name', searchable: true },
      { key: 'parameter_code', label: 'Parameter Code' },
      { key: 'display_time', label: 'Time', searchable: true },
      { key: 'display_timestamp', label: 'Timestamp' },
      { key: 'value', label: 'Value' },
      { key: 'hqc', label: 'HQC' },
      { key: 'qc2', label: 'QC2' },
      { key: 'qc1', label: 'QC1' },
      { key: 'qc0', label: 'QC0' },
    ];

    let checkedData = this.observations.map((obj) => ({
      ...obj,
      checkbox: <input type="checkbox" name="" value="" checked={obj.selected} onChange={() => this.handleRowSelectChange(obj)} />
    }))

    return (
      <div>
        <Form>
          <FormBody>
            <FormMultiSelectInput id='station-multi-select' label='Stations' options={this.multiStationOptions} optionClicked={this.onStationOptionClicked} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} />
            <FormMultiSelectInput id='parameter-multi-select' label='Parameters' options={this.multiParameterOptions} optionClicked={this.onParameterOptionClicked} isLoading={parameterStore.isLoading} filterOptions={parameterStore.filterParameters} />
            <DateInput
              label={'Date From'}
              type="datetime-local"
              value={moment(this.filters.date_from).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeFilters('date_from', e.target.value)}
            />
            <DateInput
              label={'Date To'}
              type="datetime-local"
              value={moment(this.filters.date_to).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeFilters('date_to', e.target.value)}
            />
            <div className='formInput'>
              <label>Filter by timestamp</label>
              <input type="checkbox" checked={this.filterByTimestamp} onChange={this.onChangeFilterByTimestamp} />
            </div>
            {this.filterByTimestamp && <DateInput
              label={'Timestamp From'}
              type="datetime-local"
              value={moment(this.filters.timestamp_from).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeFilters('timestamp_from', e.target.value)}
            />}
            {this.filterByTimestamp && <DateInput
              label={'Timestamp To'}
              type="datetime-local"
              value={moment(this.filters.timestamp_to).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.onChangeFilters('timestamp_to', e.target.value)}
            />}
            <DateInput
              type="time"
              label={'Time'}
              value={this.filters.time}
              onChange={e => this.onChangeFilters('time', e.target.value)}
            />
            <TextInput
              label={'QC Flag'}
              value={this.filters.qc_flag}
              onChange={e => this.onChangeFilters('qc_flag', e.target.value)}
            />
          </FormBody>
          <FormActions>
            <button onClick={this.onView}>View</button>
          </FormActions>
        </Form>
        {!this.loading && this.observations.length > 0 && <div>
          <DataTable
            columns={columns}
            data={checkedData}
            slug={'tools/delete_observation'}
          />
        </div>}
        {this.loading && <Spinner />}
        {this.observations.length > 0 && <Form>
          <FormActions>
            <button onClick={this.onChangeOpenDeleteDialog}>Delete</button>
          </FormActions>
        </Form>}
        {this.openDeleteDialog && <Modal title={'Verify Credentials'} slug={''} closeModal={this.onChangeOpenDeleteDialog} isSaving={this.deleting}>
          <Form>
            <FormBody>
              <TextInput label='Username' value={this.login.username} onChange={e => this.onChangeLogin('username', e.target.value)} />
              <TextInput label='Password' type='password' value={this.login.password} onChange={e => this.onChangeLogin('password', e.target.value)} />
            </FormBody>

            <FormActions>
              <button onClick={this.onDelete}>Delete</button>
              <button onClick={this.onChangeOpenDeleteDialog}>Cancel</button>
            </FormActions>
          </Form>
        </Modal>}
      </div>
    );
  }
}

export default DeleteObservation;


// WEBPACK FOOTER //
// ./src/components/Tools/DeleteObservation/DeleteObservation.js